import { render, staticRenderFns } from "./ChangePasswd.vue?vue&type=template&id=68ff2441&scoped=true"
import script from "./ChangePasswd.vue?vue&type=script&lang=js"
export * from "./ChangePasswd.vue?vue&type=script&lang=js"
import style0 from "./ChangePasswd.vue?vue&type=style&index=0&id=68ff2441&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_71321242e37ff7a0c7584d931db29eba/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ff2441",
  null
  
)

export default component.exports